import { HiddenGemSection } from './HiddenGemSection/HiddenGemSection';
import { AmazonSection } from './AmazonSection/AmazonSection';
import { BeforeAfterSlider } from '../components/BeforeAfterSlider';

export const GGUSection = () => {
  return (
    <div className="w-full bg-white box-border max-w-full tablet:max-w-[1280px] m-0 tablet:mx-auto">
      <div className="w-full h-full hidden desktop:block">
        <BeforeAfterSlider
          content={{
            rightSection: <HiddenGemSection />,
            leftSection: <AmazonSection />,
          }}
        />
      </div>
      <div className="w-full h-full block desktop:hidden">
        <AmazonSection />
        <HiddenGemSection />
      </div>
    </div>
  );
};
